module.exports = __webpack_public_path__ + "img/20f.fff40591.png";